import React, { Component } from 'react';

export default class Terms extends Component {
    render() {
        return (<div>
            <p>
                <small>
                    <strong>
                        <a href="https://www.councilarboriculturevictoria.com.au/terms" target="blank">Terms &amp; conditions</a>
                        <br />
                        <a href="https://www.councilarboriculturevictoria.com.au/privacy" target="blank">Privacy policy</a>
                    </strong>
                </small>
            </p>
        </div>
        );
    }
}